export type PaginationPreviewState = 'default' | 'next-page' | 'last-page'

export const PAGINATION_PREVIEW_STATES: PaginationPreviewState[] = [
  'default',
  'next-page',
  'last-page',
]

export const PAGINATION_PREVIEW_STATE_LABELS: Record<
  PaginationPreviewState,
  string
> = {
  default: 'Default',
  'next-page': 'Next page',
  'last-page': 'Last page',
}

export type PaginationProps = {
  currentPage: number
  totalPages: number
  pageSize: number
  pageSizeOptions?: number[]
  onPageChange?: (page: number) => void
  onPageSizeChange?: (pageSize: number) => void
  /** Static visual state for the design-system showcase only. */
  previewState?: PaginationPreviewState
  /** Dark surface styling. */
  darkMode?: boolean
  disabled?: boolean
  className?: string
}

export const PAGINATION_PREVIEW_CONFIG: Record<
  PaginationPreviewState,
  Pick<PaginationProps, 'currentPage' | 'totalPages' | 'pageSize'>
> = {
  default: {
    currentPage: 1,
    totalPages: 12,
    pageSize: 24,
  },
  'next-page': {
    currentPage: 2,
    totalPages: 12,
    pageSize: 24,
  },
  'last-page': {
    currentPage: 12,
    totalPages: 12,
    pageSize: 24,
  },
}
